import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class AgreementsService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('agreements/search', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('agreements/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('agreements/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('agreements/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('agreements/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('agreements/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('agreements/delete', val_id);
  }
}
